import React from 'react';
import languageIcon from '../../assets/images/language.svg';
import volumeOnIcon from '../../assets/images/volume-on.svg';
import { useLocale } from '../../hooks/useLocale';
import { useStoreActions } from '../../store';
import { LanguageMenuScreen } from '../../store/languageMenu';
import { NavRow, NavRowChevron, NavRowIcon, NavRowLabel, RootScreenContent } from './styles';

export const RootScreen = () => {
  const locale = useLocale();
  const actions = useStoreActions((actions) => actions);

  return (
    <RootScreenContent>
      <NavRow onClick={() => actions.languageMenu.navigateTo(LanguageMenuScreen.Subtitles)}>
        <NavRowIcon icon={languageIcon} />
        <NavRowLabel>{locale.translations.LanguageOptions.Subtitles}</NavRowLabel>
        <NavRowChevron />
      </NavRow>
      <NavRow onClick={() => actions.languageMenu.navigateTo(LanguageMenuScreen.Audio)}>
        <NavRowIcon icon={volumeOnIcon} />
        <NavRowLabel>{locale.translations.LanguageOptions.Audio}</NavRowLabel>
        <NavRowChevron />
      </NavRow>
    </RootScreenContent>
  );
};
